/* eslint-disable */
export const api = {
  API_URL: process.env.REACT_APP_API_URL,
  API_AUTH: process.env.REACT_APP_AUTH_URL,
  API_TOKEN: process.env.REACT_APP_TOKEN_KEY,
};
/* eslint-enable */
